import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import FirstTimeBuyerHub from "@/pages/FirstTimeBuyerHub";

export const Route = createFileRoute("/first-time-buyer/")({
  head: () => seoHead("/first-time-buyer"),
  component: FirstTimeBuyerHub,
});
